<template>
    <div class="create-account-step">
        <i class="fas fa-rocket"></i>
<!--        <h3>Get started for free</h3>-->
        <h3>Tell us a bit about yourself</h3>
        <h5>Create an account. Add your place. Live in minutes.</h5>

        <div class="form-account form-create-account">
            <ValidationObserver ref="accountForm">
                <form v-on:submit.prevent="createAccount()">
                    <ul>
                        <li>
                            <label for="name">Full Name</label>
                            <div class="row">
                                <div class="col-11">
                                    <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                        <input v-model="name" id="name" type="text" class="form-account__text">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </li>
                        <li>
                            <label for="email">Email</label>
                            <div class="row">
                                <div class="col-11">
                                    <ValidationProvider rules="required|email" v-slot="{ errors, valid }">
                                        <input v-model="email" v-on:focusout="checkEmailAndAnyExternalEstablishments(valid)" id="email" type="text" class="form-account__text">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="col-1 form-create-account__column-status">
                                    <Spinner v-show="waitingEmail" class="form__spinner--email-check"/>
                                    <i v-show="!waitingEmail && emailAllowed" class="fas fa-check text-success"></i>
                                    <i v-show="!waitingEmail && emailNotAllowed" class="fas fa-times text-error"></i>
                                </div>
                            </div>
                            <div class="row" v-if="emailNotAllowed">
                                <div class="col-11 form__error">
                                    {{emailError}}
                                </div>
                            </div>
                        </li>
                        <li>
                            <label for="mobile">Mobile</label>
                            <div class="row">
                                <div class="col-11">
                                    <ValidationProvider rules="required|min:9|max:16" v-slot="{ errors }">
                                        <vue-tel-input id="mobile"
                                                       v-model="mobile"
                                                       v-bind:mode="'international'"
                                                       v-bind:enabledCountryCode="true"
                                                       v-bind:preferredCountries="['ZA']"
                                                       v-bind:autoFormat="false"
                                                       v-bind:defaultCountry="'ZA'"
                                                       v-on:open="onTelephoneDropdownToggle(true)"
                                                       v-on:close="onTelephoneDropdownToggle(false)"
                                                       class="">
                                            <template v-slot:arrow-icon>
                                                <span>{{ isTelephoneDropdownOpen ? '▲' : '▼' }}</span>
                                            </template>
                                        </vue-tel-input>
                                        <!--                                            <input v-model="mobile" id="mobile" type="text" class="form-account__text" v-on:keydown.space.prevent>-->
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </li>
                        <li>
                            <label for="externalEstablishmentID">Are you a Nightsbridge customer?</label>
                            <span>The email above must match your email in Nightsbridge</span>
                            <div class="row">
                                <div class="col-12 form-create-account__checkbox" v-bind:class="{'form-create-account__checkbox--checked' : isPMSCustomer }">
                                    <input type="checkbox" v-model="isPMSCustomer" disabled v-on:change="changePMSCustomer"/> Yes
                                    <template v-if="isPMSCustomer && pendingEstablishments.length === 0">
                                    </template>
                                </div>
                            </div>
                            <div class="row justify-content-end" v-if="isPMSCustomer">
                                <div class="col-11">
                                    <ValidationObserver>
                                        <template v-if="pendingEstablishments.length > 0">
                                            <label for="externalEstablishmentID">Link your establishment</label>
                                            <div class="row">
                                                <div class="col-11">
                                                    <ValidationProvider v-bind:rules="{required: isMustSelectEstablishmentToLink && {allowFalse: false}}" v-slot="{ errors }">
                                                        <ul class="form-create-account__pending-establishments">
                                                            <li v-for="(establishment, index) of pendingEstablishments" v-bind:key="index">
                                                                <input type="checkbox" v-model="establishment.onboard"/> {{establishment.name}} (BBID: {{establishment.externalId}})
                                                            </li>
                                                        </ul>
                                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-11 text-center mb-2">
                                                    <strong>or</strong>
                                                </div>
                                            </div>
                                        </template>
                                        <label for="externalEstablishmentID">Enter your BBID</label>
    <!--                                    <span>Enter your BBID for a powerful integration</span>-->
                                        <div class="row">
                                            <div class="col-11">
                                                <ValidationProvider v-bind:rules="{required: isExternalEstablishmentIDRequired}" v-slot="{ errors, valid }">
                                                    <input v-model="externalEstablishmentID" v-on:focusout="checkExternalIDAndEmailForProvider(valid)" id="externalEstablishmentID" type="text" class="form-account__text">
                                                    <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                            <div class="col-1 form-create-account__column-status">
                                                <Spinner v-show="waitingPMSCheck" class="form__spinner--email-check"/>
                                                <i v-show="!waitingPMSCheck && pmsExternalIDValid" class="fas fa-check text-success"></i>
                                                <i v-show="!waitingPMSCheck && pmsExternalIDInvalid" class="fas fa-times text-error"></i>
                                            </div>
                                        </div>
                                        <div class="row" v-if="pmsExternalIDInvalid">
                                            <div class="col-11 form__error">
                                                {{pmsExternalIDMessage}}
                                            </div>
                                        </div>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </li>
                        <ValidationObserver>
                            <li>
                                <label for="password">Choose a Password</label>
                                <div class="row">
                                    <div class="col-11">
                                        <ValidationProvider vid="password" rules="required|min:6" v-slot="{ errors }">
                                            <input v-model="password" id="password" type="password" class="form-account__text">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <label for="confirm-password">Confirm password</label>
                                <div class="row">
                                    <div class="col-11">
                                        <ValidationProvider rules="required|confirm:@password|min:6" v-slot="{ errors }">
                                            <input v-model="confirmPassword" id="confirm-password" type="password" class="form-account__text">
                                            <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </li>
                        </ValidationObserver>
                    </ul>

                    <div v-if="error" class="alert alert-danger" role="alert">
                        {{error}}
                    </div>

                    <div v-show="waiting">
                        <Spinner/>
                    </div>

                    <div v-show="!waiting">
                        <button class="btn btn-primary">Create account</button>
                        <div class="form-account__alt-action">
                            <router-link to="/">Sign in instead</router-link>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import { mutations } from '@/store.js'

    import Spinner from '../Spinner.vue'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import dayjs from "dayjs"

    const VueTelInput = () =>
        Promise.all([
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
        ]).then(([{VueTelInput}]) => VueTelInput)

    export default {
        name: "Step1Host.vue",
        components: { Spinner, ValidationObserver, ValidationProvider, VueTelInput },
        data: function () {
            return {
                providers: [],
                pendingEstablishments: [],
                waitingEmail: false,
                emailAllowed: false,
                emailNotAllowed: false,
                emailError: "",
                isTelephoneDropdownOpen: false,
                waiting: false,
                error: null,
                name: "",
                email: "",
                mobile: "",
                password: "",
                confirmPassword: "",
                isPMSCustomer: true,
                externalEstablishmentID: "",
                waitingPMSCheck: false,
                pmsExternalIDValid: false,
                pmsExternalIDInvalid: false,
                pmsExternalIDMessage: "",
                hostReference: "",
            }
        },
        computed: {
            isMustSelectEstablishmentToLink() {
                console.log("Checking");
                if(this.externalEstablishmentID === "") {
                    console.log("Returning true");
                    return true;
                }
                console.log("Returning false");
                return false;
            },
            isExternalEstablishmentIDRequired() {
                for (let establishment of this.pendingEstablishments) {
                    if (establishment.onboard) {
                        return false;
                    }
                }
                return true;
            }
        },
        methods: {
            getProviders: function () {
                this.loading = true;
                this.$http.get('/guest-management/v1/data/providers', {}).then(response => {
                    if (response.data) {
                        this.providers.push(...response.data);
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
            checkEmailAndAnyExternalEstablishments: function (valid) {
                this.pendingEstablishments.splice(0, this.pendingEstablishments.length);
                this.emailNotAllowed = false;
                this.emailAllowed = false;
                this.emailError = "";
                if (valid) {
                    this.waitingEmail = true;
                    const body = {
                        email: this.email
                    }
                    this.$http.post('/guest-management/v1/users/check-email-establishments', body
                    ).then(response => {
                        this.waitingEmail = false;
                        if (response.data.valid) {
                            this.emailAllowed = true;
                            if (response.data.length > 0) {
                                this.pendingEstablishments.push(...response.data.establishments);
                            }
                        } else {
                            this.emailNotAllowed = true;
                            this.emailError = response.data.message
                        }
                    }).catch(error => {
                        this.waitingEmail = false;
                        if (error.response && error.response.data.message) {
                            this.emailNotAllowed = true;
                            this.emailError = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    })
                }
            },
            changePMSCustomer: function() {
                if (!this.isPMSCustomer)  {
                    Vue.set(this, 'isPMSCustomer', true);
                    // Ensure the DOM reflects this change
                    setTimeout(() => {
                        Vue.set(this, 'isPMSCustomer', true);
                    }, 500);
                    // if (this.pmsExternalIDInvalid === true && this.error === this.pmsExternalIDMessage) {
                        // this.error = null;
                    // }
                    // this.pmsExternalIDValid = false;
                    // this.pmsExternalIDInvalid = false;
                }
            },
            checkExternalIDAndEmailForProvider: function (valid) {
                this.pmsExternalIDValid = false;
                this.pmsExternalIDInvalid = false;
                if (valid) {
                    this.waitingPMSCheck = true;
                    const body = {
                        pmsReference: this.providers[0].reference,
                        externalEstablishmentId: this.externalEstablishmentID,
                        email: this.email
                    };
                    console.log(body);
                    this.$http.post('/guest-management/v1/users/check-external-establishment-id', body
                    ).then(response => {
                        console.log(response);
                        this.waitingPMSCheck = false;
                        if (response.data.valid) {
                            this.pmsExternalIDValid = true
                        } else {
                            this.pmsExternalIDInvalid = true;
                            this.pmsExternalIDMessage = response.data.message
                        }
                    }).catch(error => {
                        this.waitingPMSCheck = false;
                        if (error.response) {
                            this.pmsExternalIDMessage = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    })
                }
            },
            onTelephoneDropdownToggle: function (open) {
                this.isTelephoneDropdownOpen = open
            },
            onTelephoneNumberChanged: function (number, phoneObject) {
                this.mobile = phoneObject.number
            },
            createAccount: function () {
                if (this.emailNotAllowed) {
                    this.error = this.emailError;
                    return;
                }
                if (this.pmsExternalIDInvalid) {
                    this.error = this.pmsExternalIDMessage;
                    return;
                }
                this.$refs.accountForm.validate().then(success => {
                    if (!success) {
                        return
                    }
                    this.waiting = true;
                    this.error = null;
                    const body = {
                        name: this.name,
                        email: this.email,
                        mobile: this.mobile,
                        password: this.password,
                        establishments: []
                    }
                    if (this.isPMSCustomer) {
                        if (this.externalEstablishmentID) {
                            body.establishments.push({
                                provider: {reference: this.providers[0].reference},
                                externalId: this.externalEstablishmentID
                            });
                        }
                        for (let pending of this.pendingEstablishments) {
                            if (pending.onboard) {
                                body.establishments.push({
                                    provider: {reference: this.providers[0].reference},
                                    externalId: pending.externalId
                                });
                            }
                        }
                    }

                    this.$http.post('/guest-management/v1/users', body
                    ).then(response => {
                        this.waiting = false;
                        mutations.setHost(response.data);
                        this.$root.$emit("create-account-host", dayjs().format('HH:mm'));
                    }).catch(error => {
                        this.waiting = false
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    })
                })
            },
        },
        mounted() {
            this.getProviders();
        }
    }

</script>

<style lang="scss" scoped>
    @import "../../styles/pages/create-account";
</style>